import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-20 px-4 bg-brand-guarantee border-y-4 border-brand-green" data-id="element-142">
      <div className="max-w-4xl mx-auto text-center" data-id="element-143">
        <ShieldCheckIcon className="w-16 h-16 md:w-24 md:h-24 text-brand-green mx-auto mb-4 md:mb-6" data-id="element-144" />

        <h2 className="text-3xl md:text-5xl font-black text-brand-dark mb-6 md:mb-8" data-id="element-145">
          Garantía 7 días — Sin vueltas
        </h2>

        <div className="text-lg md:text-xl text-gray-800 space-y-4 font-medium mb-8 max-w-3xl mx-auto" data-id="element-146">
          <p data-id="element-147">
            Estamos tan seguros de que este material te va a servir, que te
            damos 7 días para probarlo sin ningún riesgo.
          </p>
          <p data-id="element-148">
            Si abrís el pack y sentís que no es para vos, nos escribís y te
            devolvemos el 100% del dinero.
          </p>
          <p className="font-bold text-brand-dark text-2xl py-2" data-id="element-149">
            Sin preguntas. Sin formularios. Sin demoras.
          </p>
          <p className="italic text-gray-600" data-id="element-150">
            Porque no queremos tu dinero si el material no te da valor real.
          </p>
        </div>
      </div>
    </section>;
}